var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5419 20.0002H6.45855C6.15022 20.0002 5.88772 19.7752 5.84105 19.4702L5.00772 14.0535C4.98022 13.8735 5.03188 13.6893 5.15105 13.551C5.27022 13.4127 5.44272 13.3335 5.62522 13.3335H14.3752C14.5577 13.3335 14.731 13.4135 14.8494 13.5518C14.9677 13.6902 15.0202 13.8735 14.9927 14.0543L14.1594 19.471C14.1127 19.7752 13.8502 20.0002 13.5419 20.0002Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 6.66667C11.8408 6.66667 13.3332 5.17428 13.3332 3.33333C13.3332 1.49238 11.8408 0 9.99984 0C8.15889 0 6.6665 1.49238 6.6665 3.33333C6.6665 5.17428 8.15889 6.66667 9.99984 6.66667Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3476 10.8333C19.2151 8.98583 18.2217 7.27583 16.6659 6.24167C16.6617 5.555 16.1042 5 15.4167 5C14.7267 5 14.1667 5.56 14.1667 6.25C14.1667 6.94 14.7267 7.5 15.4167 7.5C15.6451 7.5 15.8559 7.43417 16.0401 7.3275C17.2126 8.135 17.9701 9.42917 18.0976 10.8333H16.6167C16.3167 8.95 14.6834 7.5 12.7084 7.5H7.29173C5.31673 7.5 3.6834 8.95 3.3834 10.8333H0.625066C0.182566 10.8333 -0.103267 11.2817 0.0333997 11.675L1.70007 16.2583C1.79173 16.5 2.02507 16.6667 2.29173 16.6667H3.72507L3.3584 14.3083C3.2584 13.6417 3.45007 12.975 3.8834 12.4667C4.25507 12.0208 4.91257 11.6667 5.62507 11.6667H14.3751C15.0042 11.6667 15.6392 11.9258 16.1167 12.4667C16.5501 12.975 16.7417 13.6417 16.6417 14.3083L16.2751 16.6667H17.7084C17.9751 16.6667 18.2084 16.5 18.3001 16.2583L19.9667 11.675C20.0984 11.2958 19.8467 10.8333 19.3476 10.8333Z",
    fill: "#BFBFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenter);
export default __webpack_public_path__ + "static/media/presenter.f2f550ca54e6a98373c7c1f3f560d57e.svg";
export { ForwardRef as ReactComponent };